import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconLogOut = props => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <path d="m7.1 12.6 1.4 1.4 5-5-5-5-1.4 1.4 2.6 2.6h-9.7v2h9.7l-2.6 2.6zm8.9-12.6h-14c-1.1 0-2 0.9-2 2v4h2v-4h14v14h-14v-4h-2v4c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2z" />
  </SvgIcon>
);

export default IconLogOut;



// WEBPACK FOOTER //
// ./src/components/icons/IconLogOut.js